import requests from "./httpServices";

const OrderServices = {
  addOrder(body, headers) {
    return requests.post("/order/add", body, headers);
  },
  getOrderByUser(body) {
    return requests.get("/order", body);
  },
  getOrderByUserWithTotal() {
    return requests.get("/order/search/total");
  },
  getOrderById(id, body) {
    return requests.get(`/order/${id}`, body);
  },
  updateOrderStatus(id, body) {
    return requests.put(`/orders/unavailable/${id}`);
  },
  findOrderLog(id) {
    return requests.get(`/orders/${id}/log?type=Public`);
  },
};

export default OrderServices;
